import React from "react";
import { Routes, Route } from "react-router-dom";
import SharedVideoMediaMain from "./SharedVideoMediaMain";
import MediaProgressPhotoClientDetailPage from "./shared-videos/components/MediaProgressPhotoClientDetailPage";

/**
 * Media hub: videos + progress photos; per-client photo tools live under progress-photos/:clientId.
 */
const SharedVideoPage = () => {
  return (
    <Routes>
      <Route
        path="progress-photos/:clientId"
        element={<MediaProgressPhotoClientDetailPage />}
      />
      <Route path="*" element={<SharedVideoMediaMain />} />
    </Routes>
  );
};

export default SharedVideoPage;
